import React from "react";
import { Toaster } from "@/components/ui/toaster";
import Header from "./layout/Header";
import { Footer } from "./layout/Footer";
import WhatsAppButton from "./WhatsAppButton";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col dark:bg-gray-900">
      <Header />
      <main className="flex-grow dark:bg-gray-900 dark:text-gray-100">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
};

export default Layout;
